import MarginGroup from 'app/components/layout/MarginGroup';
import Modal from 'app/components/modals/Modal';
import ModalContent from 'app/components/modals/ModalContent';
import ModalTitle from 'app/components/modals/ModalTitle';
import { NetworkError, ResponseError } from 'app/constants/ResponseErrors';
import { notify } from 'app/services/errorReporter';
import React, { FC } from 'react';
import BaseButton from 'app/components/common/BaseButton';

const sensitiveData = {
  access_token: 'access_token',
  contents: 'contents',
  current_password: 'current_password',
  currentPassword: 'currentPassword',
  password_confirmation: 'password_confirmation',
  password: 'password',
  passwordConfirmation: 'passwordConfirmation',
  refresh_token: 'refresh_token',
};

interface INotifyTeseterModalProps {
  onClose: () => void;
}

const NotifyTesterModal: FC<INotifyTeseterModalProps> = ({ onClose }) => (
  <Modal onClose={onClose}>
    <ModalTitle onClose={onClose}>Test Error Reporting</ModalTitle>

    <ModalContent>
      <MarginGroup>
        <BaseButton onClick={() => notify(new Error('Simulated Error'))}>
          Send to Honeybadger
        </BaseButton>
        <BaseButton onClick={() => Promise.reject(new Error('Simulated Error'))}>
          Send to Honeybadger via unhandled rejection
        </BaseButton>
        <BaseButton onClick={() => setTimeout(() => { throw new Error('Simulated Error'); }, 0)}>
          Send to Honeybadger via window.onerror
        </BaseButton>
        <BaseButton
          onClick={() => notify(Promise.reject(new ResponseError({
            data: {
              nested: sensitiveData,
              ...sensitiveData,
            },
            status: 500,
          })), {
            context: {
              ...sensitiveData,
              nested: sensitiveData,
            },
          })}
        >
          Send to Honeybadger with sensitive data.
        </BaseButton>
        <BaseButton onClick={() => notify(new NetworkError({ response: 'Simulated Error' }))}>
          Send to Fluentd
        </BaseButton>
      </MarginGroup>
    </ModalContent>
  </Modal>
);

export default NotifyTesterModal;
